(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hello-antes-depois"] && !Shopify.designMode) return;
  try {
    
  class HelloAntesDepois extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('[data-ad-range]');
      this.clip = this.querySelector('[data-ad-clip]');
      this.line = this.querySelector('[data-ad-line]');
      if (!this.range || !this.clip || !this.line) return;

      this.apply(this.range.value);
      this.range.addEventListener('input', () => this.apply(this.range.value));
    }

    apply(value) {
      const pct = `${value}%`;
      this.clip.style.clipPath = `inset(0 ${100 - value}% 0 0)`;
      this.line.style.insetInlineStart = pct;
    }
  }

  if (!customElements.get('hello-antes-depois')) {
    customElements.define('hello-antes-depois', HelloAntesDepois);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hello-beneficios"] && !Shopify.designMode) return;
  try {
    
  class HelloBeneficios extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-benef-track]');
      this.dotsBox = this.querySelector('[data-benef-dots]');
      if (!this.track || !this.dotsBox) return;

      this.items = Array.from(this.querySelectorAll('[data-benef-item]'));
      if (this.items.length < 2) return;

      this.mobile = window.matchMedia('(max-width: 749px)');
      this.build();

      this.track.addEventListener('scroll', () => this.schedule(), { passive: true });
      window.addEventListener('resize', () => this.update());
      this.update();
    }

    build() {
      this.dots = this.items.map((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hello-benef__dot';
        dot.setAttribute('aria-label', `${index + 1}`);
        dot.addEventListener('click', () => {
          this.items[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
        this.dotsBox.appendChild(dot);
        return dot;
      });
    }

    schedule() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    }

    // Marca a bolinha do item mais próximo do centro da pista.
    update() {
      if (!this.mobile.matches) return;
      const box = this.track.getBoundingClientRect();
      const center = box.left + box.width / 2;

      let active = 0;
      let menor = Infinity;
      this.items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const dist = Math.abs(center - (rect.left + rect.width / 2));
        if (dist < menor) {
          menor = dist;
          active = index;
        }
      });

      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === active);
        dot.setAttribute('aria-current', index === active ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('hello-beneficios')) {
    customElements.define('hello-beneficios', HelloBeneficios);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hello-carrossel-beneficios"] && !Shopify.designMode) return;
  try {
    
  class HelloCarrossel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carr-track]');
      this.prev = this.querySelector('[data-carr-prev]');
      this.next = this.querySelector('[data-carr-next]');
      if (!this.track || !this.prev || !this.next) return;

      this.prev.addEventListener('click', () => this.mover(-1));
      this.next.addEventListener('click', () => this.mover(1));
      this.track.addEventListener('scroll', () => this.agendar(), { passive: true });
      window.addEventListener('resize', () => this.atualizar());
      this.atualizar();
    }

    // Anda um card por clique, medindo o card real em vez de um valor fixo.
    mover(direcao) {
      const card = this.track.querySelector('li');
      if (!card) return;
      const passo = card.getBoundingClientRect().width + this.espacamento();
      this.track.scrollBy({ left: passo * direcao, behavior: 'smooth' });
    }

    espacamento() {
      const gap = window.getComputedStyle(this.track).columnGap;
      const valor = parseFloat(gap);
      return Number.isNaN(valor) ? 0 : valor;
    }

    agendar() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.ticking = false;
        this.atualizar();
      });
    }

    atualizar() {
      const sobra = this.track.scrollWidth - this.track.clientWidth;
      // 1px de folga: navegadores arredondam o scrollLeft e a seta ficaria presa ativa.
      const noInicio = this.track.scrollLeft <= 1;
      const noFim = this.track.scrollLeft >= sobra - 1;

      this.classList.toggle('sem-rolagem', sobra <= 1);
      this.prev.disabled = noInicio;
      this.next.disabled = noFim;
    }
  }

  if (!customElements.get('hello-carrossel')) {
    customElements.define('hello-carrossel', HelloCarrossel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hello-passos"] && !Shopify.designMode) return;
  try {
    
  /*
    Mesmo elemento do carrossel de benefícios. A definição é repetida de propósito: a
    guarda no fim só registra se ainda não existir, e assim esta seção funciona sozinha
    numa página onde o carrossel de benefícios não aparece.
  */
  class HelloCarrossel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carr-track]');
      this.prev = this.querySelector('[data-carr-prev]');
      this.next = this.querySelector('[data-carr-next]');
      if (!this.track || !this.prev || !this.next) return;

      this.prev.addEventListener('click', () => this.mover(-1));
      this.next.addEventListener('click', () => this.mover(1));
      this.track.addEventListener('scroll', () => this.agendar(), { passive: true });
      window.addEventListener('resize', () => this.atualizar());
      this.atualizar();
    }

    // Anda um card por clique, medindo o card real em vez de um valor fixo.
    mover(direcao) {
      const card = this.track.querySelector('li');
      if (!card) return;
      const passo = card.getBoundingClientRect().width + this.espacamento();
      this.track.scrollBy({ left: passo * direcao, behavior: 'smooth' });
    }

    espacamento() {
      const gap = window.getComputedStyle(this.track).columnGap;
      const valor = parseFloat(gap);
      return Number.isNaN(valor) ? 0 : valor;
    }

    agendar() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.ticking = false;
        this.atualizar();
      });
    }

    atualizar() {
      const sobra = this.track.scrollWidth - this.track.clientWidth;
      // 1px de folga: navegadores arredondam o scrollLeft e a seta ficaria presa ativa.
      const noInicio = this.track.scrollLeft <= 1;
      const noFim = this.track.scrollLeft >= sobra - 1;

      this.classList.toggle('sem-rolagem', sobra <= 1);
      this.prev.disabled = noInicio;
      this.next.disabled = noFim;
    }
  }

  if (!customElements.get('hello-carrossel')) {
    customElements.define('hello-carrossel', HelloCarrossel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hello-tabbed-cards"] && !Shopify.designMode) return;
  try {
    
  class HelloTabbedCards extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      if (!this.cards.length) return;

      this.index = 0;
      this.classList.add('is-ready');

      this.querySelectorAll('[data-direction]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const step = button.getAttribute('data-direction') === 'next' ? 1 : -1;
          this.goTo(this.index + step);
        });
      });

      this.goTo(0);
    }

    goTo(index) {
      if (index < 0 || index > this.cards.length - 1) return;
      this.index = index;

      this.cards.forEach((card, i) => {
        card.classList.toggle('active', i === index);
      });

      this.querySelectorAll('[data-direction]').forEach((button) => {
        const isNext = button.getAttribute('data-direction') === 'next';
        button.disabled = isNext ? index === this.cards.length - 1 : index === 0;
      });
    }
  }

  if (!customElements.get('hello-tabbed-cards')) {
    customElements.define('hello-tabbed-cards', HelloTabbedCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initControls(scope) {
      var groups = scope.querySelectorAll('.hello-carousel-controls');
      groups.forEach(function (controls) {
        if (controls.dataset.helloBound) return;
        var section = controls.closest('.section-resource-list');
        if (!section) return;
        var scroller = section.querySelector('slideshow-slides');
        if (!scroller) return;
        controls.dataset.helloBound = '1';

        var fill = controls.querySelector('.hello-carousel-progress__fill');
        var prev = controls.querySelector('[data-dir="prev"]');
        var next = controls.querySelector('[data-dir="next"]');

        function update() {
          var max = scroller.scrollWidth - scroller.clientWidth;
          var ratio = max > 4 ? scroller.scrollLeft / max : 1;
          ratio = Math.min(1, Math.max(0.12, ratio));
          if (fill) fill.style.transform = 'scaleX(' + ratio + ')';
          if (prev) prev.disabled = scroller.scrollLeft <= 2;
          if (next) next.disabled = max <= 4 || scroller.scrollLeft >= max - 2;
        }

        function step(dir) {
          scroller.scrollBy({ left: dir * scroller.clientWidth * 0.85, behavior: 'smooth' });
        }

        if (prev) prev.addEventListener('click', function () { step(-1); });
        if (next) next.addEventListener('click', function () { step(1); });
        scroller.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        requestAnimationFrame(update);
      });
    }

    function boot() { initControls(document); }

    if (document.readyState !== 'loading') {
      boot();
    } else {
      document.addEventListener('DOMContentLoaded', boot);
    }
    document.addEventListener('shopify:section:load', function (e) { initControls(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
